import { SharedService } from './../shared.service';
import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { AppEventDispatcher } from '../../utils/AppEventDispatcher';
import { EventTypes } from '../EventTypes';
import { TweenMax, Quint } from 'gsap';
import { FormatPricePipe } from '../format-price.pipe';
import { AutenticationEventType } from '../../autentication/autentication.event.type';
import { CurrentBalanceEventType } from './current-balance.event.type';
import { Cookie } from 'ng2-cookies/ng2-cookies';
import { Auth } from '../../autentication/Auth';
import CryptoJS from 'crypto-js';

@Component({
	selector: 'app-current-balance',
	templateUrl: './current-balance.component.html',
	styleUrls: ['./current-balance.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class CurrentBalanceComponent implements OnInit, OnDestroy {
	balance: string;
	limit: string;
	balanceLimit: string;
	loading = false;
	showLimitsDetail = true;
	accountType: any;

	toggleBalance: boolean;
	user = Auth.getInstance().getUser().cpf;

	constructor(private sharedService: SharedService) { }

	ngOnInit() {
		const userCpf = CryptoJS.MD5(this.user).toString();
		const cookie = JSON.parse(Cookie.get('OmniToggleBalance' + userCpf));

		this.toggleBalance = cookie !== null ? cookie : true;

		AppEventDispatcher.listen(AutenticationEventType.ACCOUNT.CHANGE_ACCOUNT, () => {
			this.load();
		});

		AppEventDispatcher.listen(CurrentBalanceEventType.BALANCE_UPDATE, () => {
			this.load();
		});

		AppEventDispatcher.listen(EventTypes.BALANCE, data => {

			if (data.show) {
				this.showComponent();
			} else {
				this.hideComponent();
			}

		});

		this.load();

	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(AutenticationEventType.ACCOUNT.CHANGE_ACCOUNT);
		AppEventDispatcher.removeListener(CurrentBalanceEventType.BALANCE_UPDATE);
	}

	load() {
		this.loading = true;
		this.balance = this.limit = this.balanceLimit = '';
		this.sharedService.getBalance().subscribe( (data: any) => {

			const FP = new FormatPricePipe();
			this.balance = FP.transform(data.Retorno.SaldoParcial);
			this.limit = FP.transform(data.Retorno.LimiteGarantia);
			this.balanceLimit = FP.transform(data.Retorno.SaldoSaque);
			this.accountType = Auth.getInstance().getUser().accountType;
			this.showLimitsDetail = this.accountType !== 5 ? true : false;

			this.showComponent();

			this.loading = false;

		}, error => {
		});
	}

	hideComponent() {
		TweenMax.to('[data-component="current-balance"]', .8, {height: 0, marginBottom: 0, padding: '0', ease: Quint.easeOut});
		TweenMax.to('[data-component="current-balance"]', .8, {delay: .8, autoAlpha: 1, ease: Quint.easeOut});
	}

	hide() {
		TweenMax.to('[data-component="current-balance"] .balance-box', .8, {delay: .8, height: 0, marginBottom: 0, padding: 0, ease: Quint.easeOut});
		TweenMax.to('[data-component="current-balance"] .balance-box', .8, {autoAlpha: 0, ease: Quint.easeOut});
		TweenMax.to('[data-component="current-balance"]', .8, {height: 20, marginBottom: 0, padding: '0', ease: Quint.easeOut});
		TweenMax.to('[data-component="current-balance"]', .8, {delay: .8, autoAlpha: 1, ease: Quint.easeOut});
	}

	toggle() {
		this.toggleBalance = !this.toggleBalance;
		const userCpf = CryptoJS.MD5(this.user).toString();
		const cookie = JSON.parse(Cookie.get('OmniToggleBalance' + userCpf));

		if (cookie !== this.toggleBalance) {
			Cookie.set('OmniToggleBalance' + userCpf, JSON.stringify(this.toggleBalance));
		}

		if (this.toggleBalance) {
			this.show();
			AppEventDispatcher.dispatch(EventTypes.EXTRACT_TABLE_TOGGLE_BALANCE, {show: true});
		} else {
			this.hide();
			AppEventDispatcher.dispatch(EventTypes.EXTRACT_TABLE_TOGGLE_BALANCE, {show: false});
		}

	}

	show() {
		const height = this.showLimitsDetail ? 86 : 45;
		TweenMax.to('[data-component="current-balance"] .balance-box', .8, {height: height, marginBottom: 0, padding: '16px 19px', ease: Quint.easeOut});
		TweenMax.to('[data-component="current-balance"] .balance-box', .8, {delay: .8, autoAlpha: 1, ease: Quint.easeOut});
		TweenMax.to('[data-component="current-balance"]', .8, {height: height + 26, marginBottom: 20, padding: '25px 0 0', ease: Quint.easeOut});
		TweenMax.to('[data-component="current-balance"]', .8, {delay: .8, autoAlpha: 1, ease: Quint.easeOut});
	}

	showComponent() {
		const userCpf = CryptoJS.MD5(this.user).toString();
		const cookie = JSON.parse(Cookie.get('OmniToggleBalance' + userCpf));
		this.accountType = Auth.getInstance().getUser().accountType;
		this.showLimitsDetail = this.accountType !== 5 ? true : false;
		this.toggleBalance = cookie !== null ? cookie : true;

		if (this.toggleBalance) {
			this.show();
		} else {
			this.hide();
		}
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/shared/current-balance/current-balance.component.ts